export default {
  "content": "<path d=\"M10.7 14.707l-2.786 2.788 2.794 2.798-1.415 1.413L6.5 18.911l-2.792 2.796-1.415-1.414 2.794-2.798L2.3 14.707l1.415-1.414L6.5 16.08l2.785-2.787 1.415 1.414zM21.5 21h-8v-2h8v2zM21.5 16h-8v-2h8v2zM18.505 5.495H22v2h-3.495V11h-2V7.495H13v-2h3.505V2h2v3.495zM10.5 7.495h-8v-2h8v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};